/** @format */
import Page from '../../components/Page';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import MessageTemplate from '../../dao/MessageTemplate';
import swal from '../../reusables/CustomSwal';
import {
  Button,
  Card,
  Container,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import TemplateForm1 from './TemplateForm1';
import TemplateForm2 from './TemplateForm2';
import Iconify from '../../components/Iconify';
// import WAPreviewModal from "../../components/WAPreviewModal";
import WAPreviewModal from '../../components/WAPreviewFromSample';
import { LoadingButton } from '@mui/lab';

export default function TemplateCreate() {
  const navigate = useNavigate();

  const [languageOptions, setLanguageOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [name, setName] = useState('');
  const [language, setLanguage] = useState({
    id: 0,
    language: '',
    code: 'none',
  });
  const [category, setCategory] = useState({
    id: 0,
    category: '',
    code: '',
  });
  const [header, setHeader] = useState({
    type: 'HEADER',
    format: 'TEXT',
    text: '',
    example: {},
    file: {},
  });
  const [body, setBody] = useState({
    type: 'BODY',
    text: '',
    example: {},
  });
  const [footer, setFooter] = useState({
    type: 'FOOTER',
    text: '',
  });
  const [phoneNumberUrlArray, setPhoneNumberUrlArray] = useState([]);
  const [quickReplyArray, setQuickReplyArray] = useState([]);
  const [selectedButton, setSelectedButton] = useState('NONE');
  const [previewIsOpen, setPreviewIsOpen] = useState(false);
  const [firstPageLoading, setFirstPageLoading] = useState(false);
  const [secondPageLoading, setSecondPageLoading] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const { waba_id } = useParams();

  const getCategoryOptions = async () => {
    try {
      let result = await MessageTemplate.getCategory();
      result = result.map((obj) => ({
        ...obj,
        code: obj.category.toUpperCase().replace(/\s/g, '_'),
      }));
      setCategoryOptions(result);
    } catch (e) {
      await swal.fire({
        title: 'Error',
        text: 'An error has occurred. Please try again later.',
        icon: 'error',
      });
      // console.log(e);
      navigate(-1);
    }
  };

  const getLanguageOptions = async () => {
    try {
      let result = await MessageTemplate.getLanguage();
      // console.log(result);
      setLanguageOptions(result);
    } catch (e) {
      await swal.fire({
        title: 'Error',
        text: 'An error has occurred. Please try again later.',
        icon: 'error',
      });
      // console.log(e);
      navigate(-1);
    }
  };

  const nextPage = async () => {
    setFirstPageLoading(true);
    let errorMessage = '';
    if (!language.language) errorMessage = 'Please choose a language.';
    if (!name) errorMessage = 'Please enter the template name.';
    if (!category.category) errorMessage = 'Please choose a category.';

    if (errorMessage) {
      setFirstPageLoading(false);
      return await swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
      });
    } else {
      let templates = await MessageTemplate.getAll({ waba_id, limit: 10 });
      if (templates.data.find((el) => el.name === name)) {
        setFirstPageLoading(false);
        return await swal.fire({
          title: 'Error',
          text: 'Template name already exists.\nPlease enter a different name.',
          icon: 'error',
        });
      } else {
        setFirstPageLoading(false);
        setCurrentPage(2);
        window.scrollTo(0, 0);
      }
    }
  };

  const checkSampleCount = (comp) => {
    const parameter = comp.text.match(/\{{\d+}}/g);
    return parameter ?? [];
  };

  const submit = async () => {
    setSecondPageLoading(true);
    if (!body.text) {
      setSecondPageLoading(false);
      return await swal.fire({
        title: 'Error',
        text: 'Please insert body text.',
        icon: 'error',
      });
    }

    let components = [];

    if (header.format === 'TEXT') {
      if (header.text !== '') {
        let temp = { ...header };
        const headerParameter = checkSampleCount(header);

        if (headerParameter.length > 0) {
          // console.log(
          //   headerParameter.length,
          //   Object.values(header.example).length
          // );
          if (headerParameter.length !== Object.values(header.example).length) {
            setSecondPageLoading(false);
            return await swal.fire({
              title: 'Error',
              text: 'Please insert sample header text.',
              icon: 'error',
            });
          } else {
            temp.example = { header_text: [header.example[1]] };
            delete temp.file;
            components.push(temp);
          }
        } else {
          delete temp.example;
          delete temp.file;
          components.push(temp);
        }
      }
    } else {
      let temp = { ...header };
      console.log('header', header);
      if (!header.file) {
        setSecondPageLoading(false);
        return await swal.fire({
          title: 'Error',
          text: 'Please uplaod sample header file.',
          icon: 'error',
        });
      }

      temp.example = {
        header_handle: [header.file],
      };

      delete temp.text;
      delete temp.file;
      components.push(temp);
    }

    if (body) {
      let temp = { ...body };
      const bodyParameter = checkSampleCount(body);

      if (bodyParameter.length > 0) {
        if (bodyParameter.length !== Object.values(body.example).length) {
          setSecondPageLoading(false);
          return await swal.fire({
            title: 'Error',
            text: 'Please insert sample body text.',
            icon: 'error',
          });
        } else {
          temp.example = { body_text: [Object.values(body.example)] };
          components.push(temp);
        }
      } else {
        delete temp.example;
        components.push(temp);
      }
    }

    if (footer.text !== '') components.push(footer);
    //
    // if (selectedButton !== "NONE") {
    //   setSecondPageLoading(false)
    //   return await swal.fire({
    //     title: 'Error',
    //     text: 'Please insert button text',
    //     icon: 'error',
    //   })
    // }

    if (selectedButton === 'PHONE_NUMBER_URL') {
      let errorMessage = '';
      if (phoneNumberUrlArray.find((obj) => !obj.url))
        errorMessage = 'Please insert URL for button.';
      if (phoneNumberUrlArray.find((obj) => !obj.text))
        errorMessage = 'Please insert text for button.';
      if (errorMessage) {
        setSecondPageLoading(false);
        return await swal.fire({
          title: 'Error',
          text: errorMessage,
          icon: 'error',
        });
      }
      components.push({
        type: 'BUTTONS', //WILL NOT BE CHANGED
        buttons: phoneNumberUrlArray,
      });
    }

    if (selectedButton === 'QUICK_REPLY') {
      components.push({
        type: 'BUTTONS', //WILL NOT BE CHANGED
        buttons: quickReplyArray,
      });
    }

    // setSecondPageLoading(false);
    // return console.log(components);
    let popupResult = await swal.fire({
      title: 'Confirm',
      text: 'Are you sure to save this template?',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Save',
    });

    if (popupResult.isConfirmed) {
      let toSubmit = {
        category: category.code,
        language: language.code,
        name: name,
        components: components,
        waba_id: waba_id,
      };

      try {
        const data = await MessageTemplate.create(toSubmit);

        setSecondPageLoading(false);
        if (!data.error) {
          await swal.fire({
            title: 'Success',
            text: 'Message template is saved.',
            icon: 'success',
            confirmButtonText: 'Go back',
          });
          navigate(-1);
        } else {
          await swal.fire({
            title: 'Error',
            text: data.error.message,
            icon: 'error',
          });
        }
      } catch (e) {
        console.error(e);
      }
      // console.log("TOSUBMIT", toSubmit);
    }
    setSecondPageLoading(false);
  };

  console.log('HEADER', header);

  useEffect(() => {
    getCategoryOptions();
    getLanguageOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="New Message Template">
      <Container>
        <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
          <IconButton
            sx={{ p: 0, height: '100%', backgroundColor: 'white' }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
          </IconButton>
          <Typography variant="h4">New Message Template</Typography>
        </Stack>
        <Card sx={{ mb: 4, px: 4, py: 2 }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography paragraph sx={{ lineHeight: '100%', my: 'auto' }}>
              Page {currentPage}/2
            </Typography>
            {currentPage === 1 ? (
              <Stack direction="row" justifyContent="right" spacing={2}>
                <Button variant="outlined" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                <LoadingButton
                  loading={firstPageLoading}
                  variant="contained"
                  onClick={nextPage}
                >
                  Next
                </LoadingButton>
              </Stack>
            ) : (
              <Stack direction="row" justifyContent="right" spacing={2}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setCurrentPage(1);
                    window.scrollTo(0, 0);
                  }}
                >
                  Back
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => setPreviewIsOpen(true)}
                >
                  Add Sample
                </Button>
                <LoadingButton
                  loading={secondPageLoading}
                  variant="contained"
                  onClick={() => {
                    submit();
                  }}
                >
                  Save
                </LoadingButton>
              </Stack>
            )}
          </Stack>
        </Card>
        {currentPage === 1 ? (
          <TemplateForm1
            name={name}
            language={language}
            category={category}
            languageOptions={languageOptions}
            categoryOptions={categoryOptions}
            setName={setName}
            setLanguage={setLanguage}
            setCategory={setCategory}
          />
        ) : (
          <TemplateForm2
            name={name}
            language={language}
            header={header}
            body={body}
            footer={footer}
            wabaID={waba_id}
            uploadFile={uploadFile}
            setHeader={setHeader}
            setBody={setBody}
            setFooter={setFooter}
            setUploadFile={setUploadFile}
            phoneNumberUrlArray={phoneNumberUrlArray}
            setPhoneNumberUrlArray={setPhoneNumberUrlArray}
            quickReplyArray={quickReplyArray}
            setQuickReplyArray={setQuickReplyArray}
            selectedButton={selectedButton}
            setSelectedButton={setSelectedButton}
          />
        )}
      </Container>
      <WAPreviewModal
        headerFormat={header.format}
        header={header.format === 'TEXT' ? header.text : null}
        footer={footer.text}
        buttonType={selectedButton}
        buttonQuickReply={quickReplyArray}
        buttonPhoneNumberURL={phoneNumberUrlArray}
        content={body.text}
        body={body}
        headerContent={header}
        setBody={setBody}
        setHeader={setHeader}
        open={previewIsOpen}
        setOpen={setPreviewIsOpen}
      />
    </Page>
  );
}
